/**
 * @file AdUnitSearchTopSlot.tsx
 *
 * @fileoverview Renders row ad unit for the top of the job search page.
 */

import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { getFrontend } from '~/jobiqo/utils/getFrontend';

interface AdUnitSearchTopSlotProps {}

export default function AdUnitSearchTopSlot({}: AdUnitSearchTopSlotProps) {
  const frontendConfig = useFrontendConfig();
  const frontend = getFrontend(frontendConfig);
  switch (frontend) {
    case 'newsday':
      return (
        <iframe
          src="https://www.newsday.com/html/3rdparty/header.html?section=long-island&amp;subsection=jobs"
          style={{
            border: 'none',
            width: '100%',
            height: '380px',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          scrolling="no"
        ></iframe>
      );
    default:
      return null;
  }
}

export { AdUnitSearchTopSlot };
